import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GurujiTabRoutingModule } from './guruji-tab-routing.module';
import { GurujiTabComponent } from './guruji-tab.component';




import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { DfpModule } from 'ngx-dfp';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { FavouriteComponent } from './favourite/favourite.component';

import {DragDropModule} from '@angular/cdk/drag-drop';
import { NgxSpinnerModule } from "ngx-spinner";
import { GurujiCategoryComponent } from './guruji-category/guruji-category.component';

 
@NgModule({
  declarations: [GurujiTabComponent, FavouriteComponent, GurujiCategoryComponent],
  imports: [
    GurujiTabRoutingModule,
    InfiniteScrollModule,
    SharedModule,
    DfpModule,
    NgbModule,
    DragDropModule,
    NgxSpinnerModule 
  ]
})
export class GurujiTabModule { }
